import { IS_WHATS_NEW_MODAL_SHOW_QUERY_OPTIONS, hideWhatsNewModal } from '@/utils/whatsNew'
import { Modal } from '@mantine/core'
import { IconSparkles } from '@tabler/icons-react'
import { useQuery } from '@tanstack/react-query'
import type { HTMLAttributes } from 'react'
import ChangeLog from './ChangeLog'
import styles from './WhatsNewModal.module.css'

export interface WhatsNewModalProps extends HTMLAttributes<HTMLDivElement> {}

export default function WhatsNewModal({ ...props }: WhatsNewModalProps) {
	const { data: isShow } = useQuery(IS_WHATS_NEW_MODAL_SHOW_QUERY_OPTIONS)
	return (
		<Modal
			className={styles.modal}
			size="xl"
			opened={!!isShow}
			onClose={() => hideWhatsNewModal()}
			title={
				<div className={styles.title}>
					<IconSparkles />
					<span>What&#39;s New</span>
				</div>
			}
		>
			<ChangeLog />
		</Modal>
	)
}
